var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayType)?_c('div',{staticClass:"community-link"},[_c('community-type',{attrs:{"community":_vm.community}}),_c('h3',{staticClass:"community-name",on:{"click":_vm.goToCommunity}},[_vm._v(" "+_vm._s(_vm.community.name)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }